export default "__VITE_ASSET__DL0ND8x4__"